import React from 'react';
import { Component } from 'react';
import { connect } from 'react-redux';
import Table from '../../components/Table';
import { createSidebar } from '../../redux/actions/general/sidebar';
import { listTimesheetReport } from '../../redux/actions/table/timesheet_report';
import { listActiveModules } from '../../redux/actions/general/active_modules';
import Tooltip from '../../components/Tooltip';
import { __, backendURL, redirect } from '../../core/utils';
import TableNA from '../../components/TableNA';
import autobind from 'autobind-decorator';
import queryString from 'query-string';
import moment from 'moment';
import ExportIcon from '../../assets/images/export-15x15.svg';
import { downloadFile } from '../../redux/actions/general/downloader';
import { setNotification } from '../../redux/actions/general/notification';
import TimesheetReportExportWizard from '../../wizards/TimesheetReportExportWizard';
import styles from '../../styles/views/timesheets/TimesheetReport.scss';

const mapStateToProps = (state) => {
  return {
    table: state.table['timesheet_report'],
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      setTableParams: (params) =>
        dispatch({
          type: 'table.timesheet_report/SET_TABLE_PARAMS',
          params,
        }),
    },
  };
};

@connect(mapStateToProps, mapDispatchToProps)
class TimesheetReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      team_roles: [],
      showExportModal: false,
      exportMonth: String(moment().month() + 1),
      exportYear: String(moment().year()),
    };
  }

  componentDidMount() {
    createSidebar({
      title: __('submenu.title.time-log-main'),
      items: [
        {
          title: __('submenu.title.time-log-submodule'),
          link: () => '/timesheets',
        },
        {
          title: __('submenu.title.all-timesheet-reports'),
          link: () => '/timesheet_report',
          active: true,
        },
        {
          title: __('Timesheet Entries'),
          link: () => '/timesheet_entries',
        },
      ],
    });

    let params = {
      sort_by: 'date',
      order: 'desc',
    };

    const filters = {
      user: 'all',
      project: 'all',
      stage: 'all',
      substage: 'all',
      task: 'all',
      year: 'all',
      half_year: 'all',
      quarter: 'all',
      month: 'all',
      week: 'all',
      address_book_company: 'all',
    };

    _.each(Object.keys(filters), (key) => {
      params['filter.' + key] = filters[key];
    });

    this._setURLParams({
      ...params,
    });
  }

  _handleOpacity(value, row) {
    return !row.deactivated ? (
      value
    ) : (
      <div className={styles.hidden}>{value}</div>
    );
  }

  @autobind
  _setURLParams(params) {
    const search = queryString.stringify({
      ...queryString.parse(this.props.history.location.search),
      ...params,
    });
    redirect({ search }, true);
  }

  @autobind
  _openExportModal() {
    this.setState({
      showExportModal: true,
      exportMonth: String(moment().month() + 1),
      exportYear: String(moment().year()),
    });
  }

  @autobind
  _closeExportModal() {
    this.setState({
      showExportModal: false,
    });
  }

  @autobind
  _handleExport() {
    const { exportMonth, exportYear } = this.state;
    const payload = {
      year: Number(exportYear),
      month: Number(exportMonth),
    };

    setNotification(__('timesheet-report.notification.export-started'));

    downloadFile(backendURL + '/working_time_records/export', payload);

    this._closeExportModal();
  }

  render() {
    const { showExportModal, exportMonth, exportYear } = this.state;
    const totalFiltered = _.get(
      this.props.table,
      'additional_params.total_filtered',
      {}
    );
    const totalWorkingHours = Number(totalFiltered.working_hours) || 0;
    const totalAbsentHours = Number(totalFiltered.absent_hours) || 0;
    const totalOvertimeHours = Number(totalFiltered.overtime) || 0;
    const formatTotalHours = (hours) => _.round(hours, 2).toFixed(2);
    const footer = (
      <>
        <span className={styles.total}>Total working hours:</span>
        <span className={styles.number}>
          {formatTotalHours(totalWorkingHours)}
        </span>
        <span className={styles.total}>Total absent hours:</span>
        <span className={styles.number}>
          {formatTotalHours(totalAbsentHours)}
        </span>
        <span className={styles.total}>Total overtime hours:</span>
        <span className={styles.number}>
          {formatTotalHours(totalOvertimeHours)}
        </span>
      </>
    );
    const viewActions = [
      <Tooltip
        key='timesheet-report-export'
        text={__('timesheet-report.tooltip.icon.export-xls')}
      >
        <button
          type='button'
          className={styles.exportButton}
          onClick={this._openExportModal}
        >
          <ExportIcon />
        </button>
      </Tooltip>,
    ];
    const columns = [
      {
        key: 'user_name',
        name: __('table.columns.timesheet-report-user'),
        required: true,
        value: (value) => <Tooltip text={value}>{value}</Tooltip>,
      },
      // {
      //   key: 'project_name',
      //   name: __('table.columns.timesheet-report-project'),
      //   width: 100,
      //   default: true,
      //   value: (value) =>
      //     value ? (
      //       <Tooltip text={_.last(_.split(value, ': '))}>
      //         {_.first(_.split(value, ': '))}
      //       </Tooltip>
      //     ) : (
      //       <TableNA />
      //     ),
      // },
      {
        key: 'project_name',
        name: __('table.columns.timesheet-report-project-name'),
        width: 200,
        default: true,
        value: (value, row) => {
          const project = row?.project_name;
          const projectName = project ? _.last(_.split(project, ': ')) : '';

          return projectName ? (
            <Tooltip text={projectName}>{projectName}</Tooltip>
          ) : (
            <TableNA />
          );
        },
      },
      {
        key: 'project_code',
        name: __('table.columns.timesheet-report-project-code'),
        width: 90,
        default: true,
        value: (value, row) => {
          const project = row?.project_name;
          const projectCode = project ? _.first(_.split(project, ': ')) : '';

          return projectCode ? (
            <Tooltip text={projectCode}>{projectCode}</Tooltip>
          ) : (
            <TableNA />
          );
        },
      },
      {
        key: 'stage_name',
        name: __('table.columns.timesheet-report-stage'),
        width: 200,
        default: true,
        value: (value) =>
          value ? <Tooltip text={value}>{value}</Tooltip> : <TableNA />,
      },
      {
        key: 'substage_name',
        name: __('table.columns.timesheet-report-substage'),
        width: 200,
        active: false,
        value: (value) =>
          value ? <Tooltip text={value}>{value}</Tooltip> : <TableNA />,
      },
      {
        key: 'task_title',
        name: __('table.columns.timesheet-report-task'),
        width: 200,
        active: false,
        value: (value) =>
          value ? <Tooltip text={value}>{value}</Tooltip> : <TableNA />,
      },
      {
        key: 'date',
        name: __('table.columns.timesheet-report-date'),
        width: 90,
        required: true,
        value: (value) =>
          value ? <Tooltip text={value}>{value}</Tooltip> : <TableNA />,
      },
      {
        key: 'address_book_company_name',
        name: __('table.columns.timesheet-report-address-book-company-name'),
        width: 200,
        active: false,
        value: (value) =>
          value ? <Tooltip text={value}>{value}</Tooltip> : <TableNA />,
        default: true,
      },
      {
        key: 'hours',
        name: __('table.columns.timesheet-report-duration'),
        width: 90,
        default: true,
        value: (value) =>
          value ? <Tooltip text={value}>{value}</Tooltip> : <TableNA />,
      },
      {
        key: 'working_hours',
        name: __('table.columns.timesheet-report-working-hours'),
        width: 90,
        default: true,
        value: (value) =>
          value ? <Tooltip text={value}>{value}</Tooltip> : <TableNA />,
      },
      {
        key: 'absent_hours',
        name: __('table.columns.timesheet-report-absent-hours'),
        width: 90,
        default: true,
        value: (value) =>
          value ? <Tooltip text={value}>{value}</Tooltip> : <TableNA />,
      },
      {
        key: 'overtime',
        name: __('table.columns.timesheet-report-overtime'),
        width: 90,
        default: true,
        value: (value) =>
          value ? <Tooltip text={value}>{value}</Tooltip> : <TableNA />,
      },
    ];

    return (
      <>
        {showExportModal && (
          <TimesheetReportExportWizard
            exportMonth={exportMonth}
            exportYear={exportYear}
            onMonthChange={(value) => this.setState({ exportMonth: value })}
            onYearChange={(value) => this.setState({ exportYear: value })}
            onClose={this._closeExportModal}
            onSubmit={this._handleExport}
          />
        )}
        <Table
          listAction={listTimesheetReport}
          name='timesheet_report'
          footer={footer}
          title={__('submenu.title.timesheet-report')}
          columns={columns}
          onLoad={() => listActiveModules()}
          viewActions={viewActions}
        />
      </>
    );
  }
}

export default TimesheetReport;
